import React from 'react'

import styles from '../styles.module.scss'
import type { BlogFiltersState } from './BlogFilters'

interface BlogFilterTagsProps {
  activeFilters: Array<{ key: keyof BlogFiltersState; label: string }>
  onRemove: (key: keyof BlogFiltersState) => void
  onClearAll: () => void
}

const BlogFilterTags: React.FC<BlogFilterTagsProps> = ({ activeFilters, onRemove, onClearAll }) => {
  return (
    <div className={styles.tagsContainer}>
      {activeFilters.map(({ key, label }) => (
        <span key={key} className={styles.activeTag}>
          {label}
          <button
            type="button"
            className={styles.activeTagRemove}
            onClick={() => onRemove(key)}
            aria-label={`Remove ${label}`}
          >
            ×
          </button>
        </span>
      ))}
      <button type="button" className={styles.clearAllBtn} onClick={onClearAll}>
        Clear All
      </button>
    </div>
  )
}

export default BlogFilterTags
